import {Partner} from '../../model/admin/partner';
import {BaseResponse} from '../internal/baseresponse';
export class ADMPartnersResult extends BaseResponse {
  data: Array<Partner>;
}



// WEBPACK FOOTER //
// ./src/app/response/admin/admpartnersresult.ts